import get from "lodash.get";
import paths from "routes/paths";
import AbstractApiActioner from "services/cores/abstractApiActioner";

import ReportsActionTypes from "./types";
import ReportsApi from "./api";
import ReportsUtils from "./utils";

class ReportsActioner extends AbstractApiActioner {
  setList(key, list) {
    return {
      type: this.actionTypes.SET_LIST,
      key,
      value: list,
    };
  }

  setSelectedIndex(key, value) {
    return {
      type: this.actionTypes.SET_LIST_SELECTED_INDEX,
      key,
      value,
    };
  }

  setInitialized(key, value) {
    return {
      type: this.actionTypes.SET_INITIALIZED,
      key,
      value,
    };
  }

  setHoverIndex(key, value) {
    return {
      type: this.actionTypes.SET_LIST_HOVER_INDEX,
      key,
      value,
    };
  }

  setPage = (key, page) => (dispatch) => {
    dispatch(this.setInitialized(key, false));

    dispatch({
      type: this.actionTypes.SET_LIST_PAGE,
      key,
      value: page,
    });

    if (key === "weeklyList") {
      return dispatch(this.retrieveWeeklyReports());
    }
    if (key === "monthlyList") {
      return dispatch(this.retrieveMonthlyReports());
    }
  };

  setRowsPerPage = (key, rowsPerPage) => (dispatch, getState) => {
    dispatch(this.setInitialized(key, false));

    dispatch({
      type: this.actionTypes.SET_LIST_PAGE,
      key,
      value: 0,
    });

    dispatch({
      type: this.actionTypes.SET_LIST_ROWS_PER_PAGE,
      key,
      value: rowsPerPage,
    });

    const list = get(getState(), `Reports.${key}`);
    const isRowsPerPageIsGreaterThanListLength = rowsPerPage > list.length;

    if (isRowsPerPageIsGreaterThanListLength) {
      return dispatch(this.setPage(key, 0));
    }

    if (key === "weeklyList") {
      return dispatch(this.retrieveWeeklyReports());
    }
    if (key === "monthlyList") {
      return dispatch(this.retrieveMonthlyReports());
    }
  };

  retrieveWeeklyReports = () => {
    return (dispatch, getState) => {
      dispatch(this.setInitialized("weeklyList", false));
      const contractId = getState().Contract.contract.id;
      const filters = {
        ...this.utils.getFilters("default", getState().Reports.weeklyList),
        contract_id: contractId,
      };

      return this.api
        .retrieveList(filters)
        .then((list) => {
          const formattedList = this.utils.formatListFromApi(list);
          dispatch(this.setList("weeklyList", formattedList));
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    };
  };

  retrieveMonthlyReports = () => {
    return (dispatch, getState) => {
      dispatch(this.setInitialized("monthlyList", false));
      const contractId = getState().Contract.contract.id;
      const filters = {
        ...this.utils.getFilters("default", getState().Reports.monthlyList),
        contract_id: contractId,
      };

      return this.api
        .retrieveList(filters)
        .then((list) => {
          const formattedList = this.utils.formatListFromApi(list);
          dispatch(this.setList("monthlyList", formattedList));
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    };
  };

  retrieveReportsForAnalysisTab = () => {
    return (dispatch) => {
      dispatch(this.retrieveWeeklyReports());
      dispatch(this.retrieveMonthlyReports());
    };
  };
}

export default new ReportsActioner(
  "Reports",
  ReportsActionTypes,
  ReportsApi,
  ReportsUtils,
  {
    paths: {
      default: paths.api.reports.list,
    },
  }
);
